import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { CurrentProductService } from '@spartacus/storefront';
import { combineLatest, Observable, Subscription, Unsubscribable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { BaseSiteConfigService } from 'src/app/service/base-site/base-site-config.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
// tslint:disable-next-line: max-line-length
import {
  ProductDescriptionClassificationPayload,
  ProductDescriptionClassificationService,
} from 'src/app/service/product/product-description-classification.service';
import { TextShowMoreLessService } from 'src/app/service/text-show-more-less/text-show-more-less.service';

@Component({
  selector: 'app-product-description-classification',
  templateUrl: './product-description-classification.component.html',
  styleUrls: ['./product-description-classification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductDescriptionClassificationComponent implements OnInit, OnDestroy {
  resultDescriptionResult: Unsubscribable;
  resultclasificationResult: Unsubscribable;
  resultProductCode: Unsubscribable;
  descriptionResult: any;
  clasificationResult: any;
  showUniqueSelling = true;
  showProdDesc = true;
  hideUniqueDesc = false;
  logisticsTrigger: boolean;
  readMoreClicked: boolean;

  product$: Observable<any> = this.currentProductService.getProduct().pipe(
    filter(Boolean),
    map((data: any) => data),
    distinctUntilChanged()
  );

  items$: Observable<any> = combineLatest([this.product$]).pipe(
    switchMap(([product]) => this.loadData(product.code, 'BASIC'))
  );

  specifications$: Observable<any> = combineLatest([this.product$]).pipe(
    switchMap(([product]) => this.loadData(product.code, 'CLASSIFICATION'))
  );

  logisticInfo$: Observable<any> = combineLatest([this.product$]).pipe(
    switchMap(([product]) => this.loadData(product.code, 'LOGISTIC_INFO'))
  );

  logisticSubscription: Subscription;
  hasLogistInfo: boolean;

  constructor(
    private prodDescClassService: ProductDescriptionClassificationService,
    private textShowMoreLessService: TextShowMoreLessService,
    private currentProductService: CurrentProductService,
    private changeDetectorRef: ChangeDetectorRef,
    private baseSiteConfigService: BaseSiteConfigService,
    private languageService: ShimanoLanguageService
  ) {}

  ngOnInit(): void {
    this.loadSellingPoints();
    this.loadDescription();
    this.isLogisticInfoEnabled();
  }

  loadData = (code: string, option: string): Observable<any> => {
    const productDescriptioClassificationPayload: ProductDescriptionClassificationPayload = {
      productOptions: option,
      productCode: code,
    };
    return this.prodDescClassService.getProductOptions(productDescriptioClassificationPayload).pipe(
      filter(Boolean),
      map((res: any) => res)
    );
  };

  loadSellingPoints = () => {
    this.resultDescriptionResult = this.items$.subscribe((result) => {
      if (typeof result.uniqueSellingPoints !== 'undefined') {
        this.clasificationResult = result.uniqueSellingPoints;
      } else {
        this.showUniqueSelling = false;
      }
      this.changeDetectorRef.detectChanges();
    });
  };

  loadDescription = () => {
    this.resultclasificationResult = this.items$.subscribe((result) => {
      if (result.summary !== '') {
        this.textShowMoreLessService.readMoreLessTranslator();
        this.descriptionResult = this.textShowMoreLessService.textTrim(result.summary);
      } else {
        this.showProdDesc = false;
      }
      this.changeDetectorRef.detectChanges();
    });
  };
  loadDescriptionisClicked() {
    if (typeof this.readMoreClicked === 'undefined') {
      this.readMoreClicked = true;
      this.textShowMoreLessService.readMoreIsClicked(true);
    } else if (this.readMoreClicked && typeof this.readMoreClicked !== 'undefined') {
      this.readMoreClicked = false;
      this.textShowMoreLessService.readMoreIsClicked(false);
    } else {
      this.textShowMoreLessService.readMoreIsClicked(true);
      this.readMoreClicked = true;
    }
    this.loadDescription();
  }

  isLogisticInfoEnabled = () => {
    this.logisticSubscription = this.getShimanoLogisticInfo$().subscribe((siteKey) => {
      this.logisticsTrigger = siteKey === 'true';
      this.changeDetectorRef.detectChanges();
    });
  };

  getShimanoLogisticInfo$(): Observable<string> {
    const shimanoRecaptchaSitekey = 'shimano.recaptcha.sitekey';
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.show.product.logistic.info'])
      .pipe(
        map(
          (configs) =>
            configs &&
            configs
              .filter((config: any) => config.key === 'shimano.show.product.logistic.info')
              .map((res: any) => res.value)[0]
        )
      );
  }

  hasLogisticInfo(logisticInfo: any): boolean {
    if (
      logisticInfo.logisticWeightNettGram ||
      logisticInfo.logisticWeightGrossGram ||
      logisticInfo.logisticDimensionLength ||
      logisticInfo.logisticHeight ||
      logisticInfo.logisticWidth
    ) {
      this.hasLogistInfo = true;
      return true;
    } else {
      this.hasLogistInfo = false;
      return false;
    }
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnDestroy(): void {
    if (this.resultDescriptionResult) {
      this.resultDescriptionResult.unsubscribe();
    }
    if (this.resultclasificationResult) {
      this.resultclasificationResult.unsubscribe();
    }
    if (this.resultProductCode) {
      this.resultProductCode.unsubscribe();
    }
    if (this.logisticSubscription) {
      this.logisticSubscription.unsubscribe();
    }
  }
}
